/**
 * 转置处理, 适用于普通折线图，动态高度折线图
 * @param params
 */
export function transpose(params) {
    var chart = params.chart, options = params.options;
    var transpose = options.transpose;
    if (!transpose) {
        chart.coordinate('rect').transpose().scale(1, -1);
    }
    return params;
}
//# sourceMappingURL=util.js.map